import { StackSection } from "@origin-digital/ods-core";
import React from "react";
import { ContentSection } from "./ContentSection";
import { MarketingCard } from "../../../components/MarketingCard";

export const LandingPageShell: React.FC = () => (
  <StackSection
    hideGutter={{ xs: true, sm: false }}
    backgroundColor="cardBackground"
    data-id="help-support-landing-page"
    width="xlarge"
    space="none"
    paddingY={"none"}
  >
    <MarketingCard />
    <ContentSection />
  </StackSection>
);
